// extracted by mini-css-extract-plugin
export default {"root":"MemoryChatSelector_root-S5Z","remainingLabel":"MemoryChatSelector_remainingLabel-ZcM","selector":"MemoryChatSelector_selector-kVx"};